import axios from 'axios'
import { WebStorageStateStore } from 'oidc-client-ts'

// Not httpClient: its interceptor asks authService for an access token, which
// would re-enter configureOidc() while it awaits these very settings.
const bootstrapClient = axios.create({
  baseURL: '/api',
  timeout: 30000,
  withCredentials: true,
})

export async function loadOidcSettings() {
  let keycloakConfig
  const raw = sessionStorage.getItem('oidc.config')
  if (raw) {
    keycloakConfig = JSON.parse(raw)
  } else {
    const { data: status } = await bootstrapClient.get('/Status')
    keycloakConfig = status.configuration.identity
    if (!keycloakConfig) throw new Error('No identity config in /Status')
    sessionStorage.setItem('oidc.config', JSON.stringify(keycloakConfig))
  }

  const { domain, clientId, useTls } = keycloakConfig
  return {
    authority: `${useTls ? 'https' : 'http'}://${domain}`,
    client_id: clientId,
    redirect_uri: `${window.location.origin}/auth/callback`,
    post_logout_redirect_uri: `${window.location.origin}/logout`,
    userStore: new WebStorageStateStore({
      store: window.localStorage,
    }),
    response_type: 'code',
    scope: 'openid profile email organization',
    automaticSilentRenew: true,
    accessTokenExpiringNotificationTimeInSeconds: 60,
    checkSessionIntervalInSeconds: 2,
    monitorSession: true,
  }
}
